import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface GetOrderListOrderList {
  id: number
  displayMemo: string
  selectionDate: string
  selectionCount: number
  selectionType: SystemCode
  editingSystemUserId: number
  isCompleted: boolean
  selectionReason: SystemCode
  traderEnvVendorId: number
  donorEnvVendorId: number
  departmentCode: SystemCode
  budgetYear: string
  budgetBranchCode: SystemCode
  budgetDepartmentCode: SystemCode
  budgetItem: SystemCode
  collectionType: SystemCode
  handlingType: SystemCode
  acceptType: SystemCode
  shelfType: SystemCode
  equipType: SystemCode
  tooliFlag: boolean
  tooliCode: string
  tooliOrderType: string
  materialFormatCode: string
  selectionNumber: number
  rejectNumber: number
  orderNumber: number
  orderTotalNumber: number
  orderTotalPrice: number
  revision: number
}

export const defaultGetOrderListOrderList = (): GetOrderListOrderList => ({
  id: 0,
  displayMemo: '',
  selectionDate: '',
  selectionCount: 0,
  selectionType: defaultSystemCode(),
  editingSystemUserId: 0,
  isCompleted: false,
  selectionReason: defaultSystemCode(),
  traderEnvVendorId: 0,
  donorEnvVendorId: 0,
  departmentCode: defaultSystemCode(),
  budgetYear: '',
  budgetBranchCode: defaultSystemCode(),
  budgetDepartmentCode: defaultSystemCode(),
  budgetItem: defaultSystemCode(),
  collectionType: defaultSystemCode(),
  handlingType: defaultSystemCode(),
  acceptType: defaultSystemCode(),
  shelfType: defaultSystemCode(),
  equipType: defaultSystemCode(),
  tooliFlag: false,
  tooliCode: '',
  tooliOrderType: '',
  materialFormatCode: '',
  selectionNumber: 0,
  rejectNumber: 0,
  orderNumber: 0,
  orderTotalNumber: 0,
  orderTotalPrice: 0,
  revision: 0
})

export function GetOrderListOrderListFromJSON(
  json: any
): GetOrderListOrderList {
  return {
    id: exists(json, 'id') ? json.id : 0,
    displayMemo: exists(json, 'display_memo') ? json.display_memo : '',
    selectionDate: exists(json, 'selection_date')
      ? dateToPlainFormat(json.selection_date)
      : '',
    selectionCount: exists(json, 'selection_count') ? json.selection_count : 0,
    selectionType: exists(json, 'selection_type')
      ? SystemCodeFromJSON(json.selection_type)
      : defaultSystemCode(),
    editingSystemUserId: exists(json, 'editing_system_user_id')
      ? json.editing_system_user_id
      : 0, // TODO 未確認
    isCompleted: exists(json, 'is_completed') ? json.is_completed : false,
    selectionReason: exists(json, 'selection_reason')
      ? SystemCodeFromJSON(json.selection_reason)
      : defaultSystemCode(),
    traderEnvVendorId: exists(json, 'trader_env_vendor_id')
      ? json.trader_env_vendor_id
      : 0,
    donorEnvVendorId: exists(json, 'donor_env_vendor_id')
      ? json.donor_env_vendor_id
      : 0,
    departmentCode: exists(json, 'department_code')
      ? SystemCodeFromJSON(json.department_code)
      : defaultSystemCode(),
    budgetYear: exists(json, 'budget_year') ? json.budget_year : '',
    budgetBranchCode: exists(json, 'budget_branch_code')
      ? SystemCodeFromJSON(json.budget_branch_code)
      : defaultSystemCode(),
    budgetDepartmentCode: exists(json, 'budget_department_code')
      ? SystemCodeFromJSON(json.budget_department_code)
      : defaultSystemCode(),
    budgetItem: exists(json, 'budget_item')
      ? SystemCodeFromJSON(json.budget_item)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    acceptType: exists(json, 'accept_type')
      ? SystemCodeFromJSON(json.accept_type)
      : defaultSystemCode(),
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    equipType: exists(json, 'equip_type')
      ? SystemCodeFromJSON(json.equip_type)
      : defaultSystemCode(),
    tooliFlag: exists(json, 'tooli_flag') ? json.tooli_flag : false,
    tooliCode: exists(json, 'tooli_code') ? json.tooli_code : '',
    tooliOrderType: exists(json, 'tooli_order_type')
      ? json.tooli_order_type
      : '',
    materialFormatCode: exists(json, 'material_format_code')
      ? json.material_format_code
      : '',
    selectionNumber: exists(json, 'selection_number')
      ? json.selection_number
      : 0,
    rejectNumber: exists(json, 'reject_number') ? json.reject_number : 0,
    orderNumber: exists(json, 'order_number') ? json.order_number : 0,
    orderTotalNumber: exists(json, 'order_total_number')
      ? json.order_total_number
      : 0,
    orderTotalPrice: exists(json, 'order_total_price')
      ? json.order_total_price
      : 0,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
